module.exports = "/themes/js/fonts/materialdesignicons-webfont.ttf";